/** Calculates width of element's scrollbar */
const calcScrollBarWidth = (el: HTMLElement = document.body): number => {
  /** It works different for body */
  if (el === document.body) {
    return window.innerWidth - document.body.clientWidth;
  }
  /** For all other elements */
  return el.offsetWidth - el.clientWidth;
};

export default calcScrollBarWidth;
